import type { PropsWithChildren } from "react";
import Flexbox, { type FlexboxProps } from "../../common/Flexbox";
import { cn } from "$/lib/utils/functions/misc.functions";

const FiltersDisplayBox = ({
  children,
  className,
  ...props
}: PropsWithChildren<FlexboxProps>) => (
  <Flexbox
    className={cn(
      "h-full min-w-fit gap-4 rounded-xl p-4 shadow-filtersBoxShadow",
      className,
    )}
    {...props}
  >
    {children}
  </Flexbox>
);

export default FiltersDisplayBox;
